import { render } from "./EstruturaPlano.vue?vue&type=template&id=80f8ab6e&scoped=true"
import script from "./EstruturaPlano.vue?vue&type=script&lang=js"
export * from "./EstruturaPlano.vue?vue&type=script&lang=js"

import "./EstruturaPlano.vue?vue&type=style&index=0&id=80f8ab6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f8ab6e"]])

export default __exports__